




































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import SuporteSalasCentrosCirurgicosStore from '@/components/Suporte/Store/SuporteSalasCentrosCirurgicosStore'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { onlyNumber } from '@/utils/common'

@Component
export default class ComponentModalSuporteSalaCirurgica extends Vue {
  loadSaveOrUpdateSalaCirurgica: boolean = false
  isSearchRoomTypeLoading: boolean = false

  get getSuporteSalasCentrosCirurgicosStore() {
    return getModule(SuporteSalasCentrosCirurgicosStore, this.$store)
  }

  get centrosCirurgicosAtivos() {
    return this.getSuporteSalasCentrosCirurgicosStore.centrosCirurgicos.filter(
      (centroCirurgico: any) => centroCirurgico.status,
    )
  }

  get loadingSaveOrUpdateSalaCirurgica() {
    return this.loadSaveOrUpdateSalaCirurgica
  }

  set loadingSaveOrUpdateSalaCirurgica(value: boolean) {
    this.loadSaveOrUpdateSalaCirurgica = value
  }

  get showModalSalaCirurgica() {
    return this.getSuporteSalasCentrosCirurgicosStore.modal.salaCirurgica
  }

  set showModalSalaCirurgica(value: boolean) {
    this.getSuporteSalasCentrosCirurgicosStore.setModal({
      name: 'salaCirurgica',
      value,
    })
  }

  $refs!: {
    formSalaCirurgica: any
  }

  formSalaCirurgicaRules: any = {
    valid: true,
    nome: [(v: any) => !!v || 'Campo obrigatório.'],
    horaInicio: [(v: any) => !!v || 'Campo obrigatório.'],
    horaFim: [(v: any) => !!v || 'Campo obrigatório.'],
    tempoPreparacao: [(v: any) => !!v || 'Campo obrigatório.'],
    status: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  onlyNumberUtil(value: any) {
    return onlyNumber(value)
  }

  async saveOrUpdateSalaCirurgica() {
    this.loadingSaveOrUpdateSalaCirurgica = true

    if (this.$refs.formSalaCirurgica.validate()) {
      const { mode } = this.getSuporteSalasCentrosCirurgicosStore

      const response = await this.getSuporteSalasCentrosCirurgicosStore.upsertSalaCirurgica()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Sala cirúrgica ${
            mode === 'CREATE' ? 'criada' : 'alterada'
          } com sucesso! ${String.fromCodePoint(0x1f642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getSuporteSalasCentrosCirurgicosStore.getSalasCirurgicasPagedSearch(
          this.getSuporteSalasCentrosCirurgicosStore.paginationSalasCirurgicas,
        )
        this.showModalSalaCirurgica = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message
            ? `${response.message} ${String.fromCodePoint(0x1f615)}`
            : `Ocorreu um erro ao ${
              mode === 'CREATE' ? 'criar' : 'alterar'
            } a sala cirúrgica ${String.fromCodePoint(0x1f615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateSalaCirurgica = false
  }

  @Watch('showModalSalaCirurgica')
  onChangeshowModalSalaCirurgica(value: boolean) {
    if (!value) {
      this.getSuporteSalasCentrosCirurgicosStore.clearSalaCirurgica()
      this.getSuporteSalasCentrosCirurgicosStore.setMode({ mode: 'CREATE' })
      this.$refs.formSalaCirurgica.resetValidation()
    }
  }
}
